// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1mfCH","topBottomGutter":"Layout_topBottomGutter__1YcNG"};